import styles from '../Table/Table.module.css'

import React from 'react'
import { Skeleton, IconButton } from '@mui/material'

import { RiFilter2Line } from "react-icons/ri";
import { FaSort } from 'react-icons/fa';

function SkeletonTable({ columns, rows }) {
  return (
    <div className={styles.tableFixHead} data-testid='skeleton-table'>
      <table>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.header}>
                <div className={styles.thDiv}>
                  {column.header}
                  <span className={styles.sortSpan}>
                    {column.enableColumnFilter
                      ? <span className={styles.filterOpener}>
                        <IconButton>
                          < RiFilter2Line />
                        </IconButton>
                      </span>
                      : column.enableSorting
                        ? < FaSort />
                        : null
                    }
                  </span>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from(Array(rows), (e, i) => {
            return (
              <tr key={i}>
                {columns.map((column) => (
                  <td key={column.header} style={{ width: column.width }}>
                    <Skeleton animation='wave' />
                  </td>
                ))}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
export default SkeletonTable
